import { render } from "./CheckoutContactData.vue?vue&type=template&id=2b0e3104&scoped=true"
import script from "./CheckoutContactData.vue?vue&type=script&lang=js"
export * from "./CheckoutContactData.vue?vue&type=script&lang=js"

import "./CheckoutContactData.vue?vue&type=style&index=0&id=2b0e3104&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0e3104"]])

export default __exports__